import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormControl } from 'react-bootstrap';

const RefinerContainer = styled.div`
    display: flex;
    margin:20px 0px;
    align-items: center;
    justify-content: flex-start;    

    h4 {
        flex: 0 0 auto;
        margin-right: 20px;
    }

    select {
        max-width: 20%;
    }

    button {
        background:none!important;
        color:inherit;
        border:none; 
        padding:0!important;
        font: inherit;
        border-bottom:1px solid #444; 
        cursor: pointer;
        margin-left:20px;
    }
`
const DateSearchRefiner = ({ 
    formType,
    refinerOptions,
    changeHandler,
    clearHandler,
    selectedValue,
}) => (
    <RefinerContainer>
        <h4>Refine by {formType}</h4>
        <FormControl value={selectedValue} onChange={changeHandler} componentClass="select">
            <option key={0} value="">select...</option>
            {refinerOptions.map((item, index) => (
                <option key={index} value={item.value}>{item.value}</option>
            ))}
      </FormControl>
      {selectedValue !== '' && 
        <button onClick={clearHandler}>clear filter</button>
        }
    </RefinerContainer>
);

DateSearchRefiner.propTypes = {
    formType: PropTypes.string,
    refinerOptions: PropTypes.arrayOf(PropTypes.shape({
        count: PropTypes.number,
        value: PropTypes.string,
    })),
    changeHandler: PropTypes.func,
    clearHandler: PropTypes.func,
    selectedValue: PropTypes.string,
}

export default DateSearchRefiner;




// WEBPACK FOOTER //
// ./src/components/searchResults/components/dateSearchRefiner.js